export enum EntityBadgeSize {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}
